/**
 * Created by kelen on 2017/3/11.
 */

(function () {
  var lastTime = 0;
  var vendors = ['webkit', 'moz'];
  for (var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
    window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
    window.cancelAnimationFrame =
      window[vendors[x] + 'CancelAnimationFrame'] || // Webkit中此取消方法的名字变了
      window[vendors[x] + 'CancelRequestAnimationFrame'];
  }

  if (!window.requestAnimationFrame) {
    window.requestAnimationFrame = function (callback, element) {
      var currTime = new Date().getTime();
      var timeToCall = Math.max(0, 16.7 - (currTime - lastTime));
      var id = window.setTimeout(function () {
        callback(currTime + timeToCall);
      }, timeToCall);
      lastTime = currTime + timeToCall;
      return id;
    };
  }
  if (!window.cancelAnimationFrame) {
    window.cancelAnimationFrame = function (id) {
      clearTimeout(id);
    };
  }
})();

const util = {
  addScript: (url, options = {}, cb) => {
    const script = document.createElement('script');
    script.src = url;
    script.async = true;
    script.onload = cb;
    for (let key in options) {
      script.setAttribute(key, options[key]);
    }
    document.head.append(script);
  },
  throttle: function (fn, ms) {
    var timer, lastArgs, lastTime;
    return function () {
      var context = this;
      var args = arguments;
      var now = Date.now();
      if (lastTime && now - lastTime < ms) {
        clearTimeout(timer);
        timer = setTimeout(
          function () {
            lastTime = now;
            fn.apply(context, args);
          },
          ms - (now - lastTime)
        );
      } else {
        lastTime = now;
        fn.apply(context, args);
      }
    };
  },
  debounce: function (fn, delay) {
    var timer;
    return function () {
      timer && clearTimeout(timer);
      var context = this;
      var args = arguments;
      timer = setTimeout(function () {
        timer = setTimeout(function () {
          fn.apply(context, args);
        }, delay);
      }, delay);
    };
  },
  supportWebp: (function () {
    // webp功能测试数据
    var images = {
      basic:
        'data:image/webp;base64,UklGRjIAAABXRUJQVlA4ICYAAACyAgCdASoCAAEALmk0mk0iIiIiIgBoSygABc6zbAAA/v56QAAAAA==',
      lossless:
        'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=',
    };
    return function (feature, cb) {
      var img = new Image();
      img.onload = function () {
        if (this.width === 2 && this.height === 1) {
          cb(null, 1);
        } else {
          cb('no support');
        }
      };
      img.onerror = function () {
        cb('no support');
      };
      img.src = images[feature || 'basic'];
    };
  })(),
  addEvent(obj, type, fn) {
    if (obj) {
      if (obj.attachEvent) {
        obj['e' + type + fn] = fn;
        obj[type + fn] = function () {
          obj['e' + type + fn](window.event);
        };
        obj.attachEvent('on' + type, obj[type + fn]);
      } else {
        obj.addEventListener(type, fn, false);
      }
    }
  },
  removeEvent(obj, type, fn) {
    if (obj) {
      if (obj.attachEvent) {
        obj['e' + type + fn] = fn;
        obj[type + fn] = function () {
          obj['e' + type + fn](window.event);
        };
        obj.detachEvent('on' + type, obj[type + fn]);
      } else {
        obj.removeEventListener(type, fn, false);
      }
    }
  },
  getScrollTop() {
    return (
      document.documentElement.scrollTop ||
      window.pageYOffset ||
      document.body.scrollTop
    );
  },
  serialForm(form) {
    let data = {},
      elem;
    for (let i = 0; i < form.elements.length; i++) {
      elem = form.elements[i];
      if (elem.name) {
        data[elem.name] = {
          el: elem,
          val: elem.value,
        };
      }
    }
    return data;
  },
  DOMready(fn) {
    if (document.addEventListener) {
      document.addEventListener(
        'DOMContentLoaded',
        function () {
          document.removeEventListener(
            'DOMContentLoaded',
            arguments.callee,
            false
          );
          fn();
        },
        false
      );
    }
    // 如果IE
    else if (document.attachEvent) {
      // 确保当页面是在iframe中加载时，事件依旧会被安全触发
      document.attachEvent('onreadystatechange', function () {
        if (document.readyState == 'complete') {
          document.detachEvent('onreadystatechange', arguments.callee);
          fn();
        }
      });

      // 如果是IE且页面不在iframe中时，轮询调用doScroll 方法检测DOM是否加载完毕
      if (
        document.documentElement.doScroll &&
        typeof window.frameElement === 'undefined'
      ) {
        try {
          document.documentElement.doScroll('left');
        } catch (error) {
          return setTimeout(arguments.callee, 20);
        }
        fn();
      }
    }
  },
};

export default util;
